<!-- src/views/projects/edit.vue -->
<template>
  <form @submit.prevent="handleSubmit">
    <section class="container">
      <div class="row">
        <div class="col">
          <div class="mb-2 d-sm-flex align-items-center justify-content-between">
            <h2 class="mb-sm-0">{{ $t('page.projects.edit_title') }}</h2>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <div class="d-flex justify-content-between">
            <div>
              <h3 class="card-title"></h3>
              <p class="card-title-desc"></p>
            </div>
            <div>
              <button class="btn btn-sm btn-primary me-2" id="home" @click.prevent="handleIndex()" :title="$t('common.home')">
                <i class="fa fa-home"></i> {{ $t('common.home') }}
              </button>
              <button class="btn btn-sm btn-primary me-2" id="new" @click.prevent="handleCreate()" :title="$t('common.create')">
                <i class="fa fa-plus"></i> {{ $t('common.create') }}
              </button>
              <button class="btn btn-sm btn-success" id="save" type="submit" :title="$t('common.save')">
                <i class="fa fa-save"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div v-if="!form" class="text-center">
            <div>Loading...</div>
            <i class="fa fa-spinner fa-spin"></i>
          </div>

          <Form v-model:form="form" :errors="errors" v-if="form" />
        </div>
        <div class="card-footer">
          <div class="text-center">
            <button class="btn btn-sm btn-success" type="submit"><i class="fa fa-save"></i> {{ $t('common.save') }}</button>
          </div>
        </div>
      </div>
    </section>
  </form>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useProjectStore } from '@/stores/projectStore';
import { useI18n } from 'vue-i18n';
import { toast } from 'vue3-toastify';
import Form from './_form';

// Consts
const route = useRoute();
const router = useRouter();
const projectStore = useProjectStore();
const { t } = useI18n();
const form = ref({});
const errors = ref({});

// Submit
const handleSubmit = async () => {
  const projectId = route.params.id;
  try {
    await projectStore.updateproject(projectId, form.value);
    await toast.success(t('common.updated'), { autoClose: 3000 });
    router.push({ name: 'projects-index' });
  } catch (error) {
    if (error.response.data.errors) {
      errors.value = error.response.data.errors;
    }
    toast.error(t('common.editError'));
  }
};

// Go to Index
const handleIndex = () => {
    router.push({ name: "projects-index" });
};

// Go to Create
const handleCreate = () => {
    router.push({ name: "projects-create" });
};

// Mounted
onMounted(async () => {
  const projectId = route.params.id;
  const project = await projectStore.getProject(projectId);
  form.value = project;
});
</script>

<style scoped>
.fa-spin {
  margin: 10px 0;
  width: 30px;
  height: 30px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>